
import { defineComponent } from "vue";
import { appVersion } from "../helpers/read-app-version";

export default defineComponent({
  name: "AboutCardContent",
  data() {
    return {
      versionString: "???",
    };
  },
  mounted() {
    appVersion.then((version) => (this.versionString = version)).catch(() => (this.versionString = "???"));
  },
});
